export const getBtnAriaLabelText = (type: string): string => `Switch to ${type} view`;
